import { useFeatureSwitches } from 'hooks/api/useFeatures'

import { customerDocsFor } from './sources'

import type { DocsSource } from './source'
import type { FeatureSwitches } from 'constants/featureSwitches'

/**
 * VRG-680 — the customer docs a brand may see right now, gated on the API's launch switches
 * (`GET /features`), read at run time so a flip needs no redeploy. Off — including while the
 * answer is loading — a gated guide is absent from nav, search and Ask, and its route shows
 * the not-found state an unpublished guide does.
 *
 * `switches` is returned too, for the body readers (`getDocBody`) that resolve gated blocks
 * inside an otherwise ungated guide.
 */
export const useCustomerDocs = (): { source: DocsSource; switches: FeatureSwitches; isKnown: boolean } => {
  const { switches, isKnown } = useFeatureSwitches()
  return { source: customerDocsFor(switches), switches, isKnown }
}
